export const CHATBOT_TOKEN_KEY = 'AccessToken';
export const CHATBOT_TOKEN = '074a9ec8ca1c4030a7c4491a4d42a081';
export const CHATBOT_SERVER_URL = 'https://api.api.ai/v1/';
export const CHATBOT_NAME = 'WR Assistant';
export const CHATBOT_CP_MODULE = 'CP';
export const CHATBOT_WP_MODULE = 'WP';


// WEBPACK FOOTER //
// ./src/app/shared/constants/chatbot-constants.ts